import React from 'react';
// import { Translation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import styles from './pastseason.module.css';
import {numberWithCommas, Tier_CDN_URI as MAIN_CDN_URI, seasonDisplayName} from '../common/utilities';

/*

    Display a Past Season Data

              seasonNo={data.PARTKEY_SEASON_NO}
              mode={data.MODE_NO_DESC}
              rank_score={data.RANK_SCORE}
              ranking={data.RANKING}
              win={data.WIN}
              games={data.MATCH_COUNT}
              draw={data.DRAW}
              kill={data.KILL}
              death={data.DEATH}
              tier_id={data.TIER_GROUP_ID}
              tier_name={data.TIER_GROUP_NAME}
              tier_stage={data.TIER_GROUP_STAGE}
              TIER_STAGE8_COUNT={data.TIER_STAGE8_COUNT}

*/

export default function PastSeason(props) {
    const { t, i18n } = useTranslation();
	const topOneHundredPoints = 4000;
	const topOneHundredTier = 11;
	const topOneHundredRankName = t("Top 100");
	const pathOfGloryTier = 8;
    const soulOfGloryTier = 9;
    const conquerorOfGloryTier = 10;
    const soulOfGloryTierPercentage = 30;
    const conquerorOfGloryTierPercentage = 20;
	const pathOfGloryRankName = t("Path of Glory");
    const soulOfGloryRankName = t("Soul of Glory");
    const conquerorOfGloryRankName = t("Conqueror of Glory");
	const changeTierLevelTypeNumber = 7; // tier levels change from 5 to 4 after tier level 7 -- I think

    function getWinRate(win, loss, count){
        count = (typeof count !== 'undefined') && '' !== count && (parseInt(count, 10) > 0 ) ? parseInt(count, 10) : 0;
        win = (typeof win !== 'undefined') && '' !== win && (parseInt(win, 10) > 0 ) ? parseInt(win, 10) : 0;
        loss = (typeof loss !== 'undefined') && '' !== loss && (parseInt(loss, 10) > 0 ) ? parseInt(loss, 10) : 0;

        if(!count && win && loss){
            return ((win / (win + loss)) * 100).toFixed(1) + '%';
        }

        if(count && win){
            return ((win / (count)) * 100).toFixed(1) + '%';
        }

        if(loss && !win){
            return '0.0%';
        }
        return 0;
    }

    function createTierImage(tier) {

		/*
			For reference:

			Bronze - 1
			Silver - 2
			Gold -3
			Platinum - 4
			Diamond - 5
			Master - 6
			Grand Master - 7
			Path of Glory - 8
            Soul of Glory - 9 (when in top 30% of all Path of Glory Tier)
            Conqueror of Glory - 10 (when in top 20% of all Path of Glory Tier)
			Top 100 - 11 (when tier points >= 4000 and rank between 1 and 100)
		*/

        tier = (typeof tier !== 'undefined') && '' !== tier && (parseInt(tier, 10) > 0) ? parseInt(tier, 10) : 0;

        // default img tier
        var defaultTier = 0;

        var myTier = (tier) ? tier : defaultTier;
        var img = 'tier-' + myTier + '-200.png';

        return img;
    }

	// pre season 14 calculation
    function oldCreateStageImage(stage) {

        // NA currently has 6 stages
        var maxStages = 6;

        stage = (typeof stage !== 'undefined') && '' !== stage && (parseInt(stage, 10) > 0 &&  parseInt(stage, 10) <= maxStages) ? parseInt(stage, 10) : 0;

        var img = (stage) ? 'tier-bar' + stage + '.png' : null;

        return img;
    }

    function createStageImage(stage, tier) {

        stage = (typeof stage !== 'undefined') && '' !== stage && (parseInt(stage, 10) > 0) ? parseInt(stage, 10) : 0;

		tier = (typeof tier !== 'undefined') && '' !== tier && (parseInt(tier, 10) > 0) ? parseInt(tier, 10) : 0;

		var levelType = null;
		switch (tier){
			case 1: case 4: levelType = 5; break;
			case 2: case 3: case 5: case 6: levelType = 6; break;
			case 7: levelType = 4; break;
			default: stage = 0;
		}

		// img name follows this pattern: tier-level-3-5.png tier-level-{stage}-{levelType}.png -- I think

        var img = (stage) ? 'tier-level-' + stage + '-' + levelType + '.png' : null;

        return img;
    }

	// show different tier level data for season 12 and 13
    function createModStageImage(stage, tier) {

        stage = (typeof stage !== 'undefined') && '' !== stage && (parseInt(stage, 10) > 0) ? parseInt(stage, 10) : 0;
		tier = (typeof tier !== 'undefined') && '' !== tier && (parseInt(tier, 10) > 0) ? parseInt(tier, 10) : 0;

		var levelType = null;
		switch (tier){
			case 1: case 2: case 3: case 4: case 5: case 6: levelType = 5; break;
			case 7: levelType = 4; break;
			default: stage = 0;
		}

		// there are a max 5 stages
		stage = (stage >= 5 && tier < changeTierLevelTypeNumber) ? 5 : stage;

		// img name follows this pattern: tier-level-3-5.png tier-level-{stage}-{levelType}.png -- I think

        var img = (stage) ? 'tier-level-' + stage + '-' + levelType + '.png' : null;

        return img;
    }

    function getRank(mode, name, stage, tierID){

        stage = (typeof stage !== 'undefined') && '' !== stage && (parseInt(stage, 10) > 0) ? parseInt(stage, 10) : 0;
        name = ((typeof name !== 'undefined') && '' !== name) ? name : 0;
        mode = ((typeof mode !== 'undefined') && '' !== mode) ? t(mode) : '-';

		// It does not appear necessary to display the stage - actually maybe it is ...
        if(mode && stage && name){
			if(topOneHundredTier == tierID || pathOfGloryTier == tierID || soulOfGloryTier == tierID){
				return mode + ' ' + name;
			}else{
                return (window._region === 'BR')
                        ? mode + ' ' + name
                        : mode + ' ' + name + ' ' + stage;
			}
		}else{
            return t('{{mode}} Unranked', { mode });
		}
    }

	// calculate if mercenary is a Top 100 grand master (RANK_SCORE >= 4000, RANKING between 1 and 100)
	var tempRanking = parseInt(props.ranking,10);
	var tempTierID = parseInt(props.tier_id,10);
	var tempRankScore = parseInt(props.rank_score,10);
    const TIER_STAGE8_COUNT = parseInt(props.TIER_STAGE8_COUNT,10);
    const COGSeasonNum = 28;

	//console.log("-------------------- Mercenary has tempRankScore (before recalculation): " + tempRankScore);

	//console.log("-------------------- Mercenary has tempTierID (before recalculation): " + tempTierID);

	//console.log("-------------------- Mercenary has tempRanking (before recalculation): " + tempRanking);


	// calculate path of glory before top 100

	var calculatedTierID = (tempTierID && (tempRankScore >= topOneHundredPoints))
						? pathOfGloryTier
						: tempTierID;


	var calculatedTierName = (calculatedTierID == pathOfGloryTier) ? pathOfGloryRankName : props.tier_name

	var mySeasonINTNumber = parseInt(props.seasonNo, 10) + 0;

	//console.log("-------------------- ");
	//console.log("-------------------- Mercenary has calculatedTierName: " + calculatedTierName);
	//console.log("-------------------- ");

	//https://jira.smilegatewest.com/browse/CFSA-14275
	// show soul of glory after season 22

	if(21 <= mySeasonINTNumber){

        // calculate soul of glory tier
        //console.log('calculate soul of glory');
        //console.log('count: ' + TIER_STAGE8_COUNT + ' rank: ' + tempRanking + ' tierID: ' + calculatedTierID);
        if(TIER_STAGE8_COUNT && tempRanking && calculatedTierID >= pathOfGloryTier){
            calculatedTierID = (((tempRanking/TIER_STAGE8_COUNT) * 100) <= soulOfGloryTierPercentage) ? soulOfGloryTier : calculatedTierID;
            calculatedTierName = (calculatedTierID == soulOfGloryTier) ? soulOfGloryRankName : calculatedTierName;

            // calculate conqueror of glory tier
            if(calculatedTierID >= soulOfGloryTier && mySeasonINTNumber >= COGSeasonNum)
            {
                calculatedTierID = (((tempRanking/TIER_STAGE8_COUNT) * 100) <= conquerorOfGloryTierPercentage) ? conquerorOfGloryTier : calculatedTierID;
                calculatedTierName = (calculatedTierID == conquerorOfGloryTier) ? conquerorOfGloryRankName : calculatedTierName;
            }
        }
    }

	// calculate top 100

	calculatedTierID = (tempTierID && (tempRankScore >= topOneHundredPoints) && (tempRanking >= 1 && tempRanking <=100))
						? topOneHundredTier
						: calculatedTierID;

	calculatedTierName = (calculatedTierID == topOneHundredTier) ? topOneHundredRankName : calculatedTierName

	//console.log("-------------------- ");
	//console.log("-------------------- Mercenary has calculatedTierName: " + calculatedTierName);
	//console.log("-------------------- ");

    var CDN_URI = `${MAIN_CDN_URI}imgs/tiers/`;
    // tier-1-100.png

    var noScores = t('No Scores to Display');

    var myTierStage = (createStageImage(props.tier_stage, calculatedTierID)) ? <img src={CDN_URI + createStageImage(props.tier_stage, calculatedTierID)} alt="Tier Stage" /> : null;

	//console.log("Mercenary has TierStage (before recalculation): " + myTierStage);

    var mySeason = t('Season {{x}}', { x: seasonDisplayName(mySeasonINTNumber) });

	// modify the tier stage if required (season 12 and 13; maximum 5 stages)
	var updatedTierStage = props.tier_stage;

	//https://jira.smilegatewest.com/browse/CW-11414
	// show different tier level data for season 14
	//if((12 == mySeasonINTNumber || 13 == mySeasonINTNumber)){
	if((12 >= mySeasonINTNumber)){

		//console.log("-------------------- We doin' season " + mySeasonINTNumber);


		myTierStage = (createModStageImage(props.tier_stage, calculatedTierID)) ? <img src={CDN_URI + createModStageImage(props.tier_stage, calculatedTierID)} alt="Tier Stage" /> : null;
		updatedTierStage = (updatedTierStage >= 5 && calculatedTierID < changeTierLevelTypeNumber) ? 5 : updatedTierStage;

		//console.log("-------------------- Mercenary has TierStage: " + myTierStage);
		//console.log("-------------------- Mercenary has updatedTierStage: " + updatedTierStage);
	}

    //var myMode = getRank(props.mode, props.tier_name, props.tier_stage);
	var myMode = getRank(props.mode, calculatedTierName, updatedTierStage, calculatedTierID);


    var myKills = (props.kill) ? numberWithCommas(parseInt(props.kill, 10) + 0) : 0;
    var myDeaths = (props.death) ? numberWithCommas(parseInt(props.death, 10) + 0) : 0;
    var myWins = (props.win) ? numberWithCommas(parseInt(props.win, 10) + 0) : 0;
    var myLosses = (props.lose) ? numberWithCommas(parseInt(props.lose, 10) + 0) : 0;
    var myGames = (props.games) ? numberWithCommas(parseInt(props.games, 10) + 0) : 0;
    var myWinRate = getWinRate(props.win, props.lose, props.games);

    // Sometimes props.ranking = 0 (it's probably just test data), but does not reflect actual ranking so I'll use something else...
    //var myRank = (props.ranking) ? '#' + props.ranking : 'No Scores to Display';

    var myRank = null;
    if(props.ranking){
        myRank = '#' + props.ranking;
    }else if(props.win || props.myGames || props.lose){
        // the player has done 'something' so just because they suck and have 0 ranking doesn't mean we shouldn't display their lame ranking
        myRank = '#' + props.ranking;
    }

    var currentStyle = (myRank) ? styles.pastSeason : styles.pastSeason + ' ' + styles.unranked;

    return (
        <div className={currentStyle}>
            <div className={styles.tierText}>
                <h3>{mySeason}</h3>
            </div>

            <div className={styles.tierImg}>
                <div className={styles.tierImgContainer}><img src={CDN_URI + createTierImage(calculatedTierID)} alt="Tier Img" /></div>
                <div className={styles.tierStageContainer}>{myTierStage}</div>
            </div>

            <div className={styles.tierText}>
                <h5>{myMode}</h5>
                <h3>{(myRank) ? myRank : noScores}</h3>
            </div>

            <div className={styles.text}>
                <div className={styles.statValueFlexContainer}>
                    <h5>{t('Kills')}</h5>
                    <h3>{myKills}</h3>
                </div>

                <div className={styles.statValueFlexContainer}>
                    <h5>{t('Deaths')}</h5>
                    <h3>{myDeaths}</h3>
                </div>

                <div className={styles.statValueFlexContainer}>
                    <h5>{t('Wins')}</h5>
                    <h3>{myWins}</h3>
                </div>


                <div className={styles.statValueFlexContainer}>
                    <h5>{t('Losses')}</h5>
                    <h3>{myLosses}</h3>
                </div>

                <div className={styles.statValueFlexContainer}>
                    <h5>{t('Win Rate')}</h5>
                    <h3>{myWinRate}</h3>
                </div>

                <div className={styles.statValueFlexContainer}>
                    <h5>{t('Total Games Played')}</h5>
                    <h3>{myGames}</h3>
                </div>
            </div>
        </div>
    );
}
